import { render } from "./menuTreeNode.vue?vue&type=template&id=2927f464&ts=true"
import script from "./menuTreeNode.vue?vue&type=script&lang=ts"
export * from "./menuTreeNode.vue?vue&type=script&lang=ts"

import "./menuTreeNode.vue?vue&type=style&index=0&id=2927f464&lang=less"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__